<template>
  <a-spin :spinning="loading">
    <div
      class="home"
      :style="{
        backgroundImage: 'url(' + imagePath.homeBGI + ')',
      }"
    >
      <common-header></common-header>
      <div class="content">
        <div class="tips"><img :src="imagePath.homeTitle" alt="" /></div>
        <div class="list">
          <!-- backgroundImage: `url(${getbgi(index, item.auth)})`, -->
          <div
            class="item cp"
            v-for="item in listData"
            :key="item.catId"
            @click="goHomeDetail(item)"
          >
            <img
              class="itemBGI"
              :src="item.imgUrl"
              :style="{
                filter: !item.auth ? 'brightness(60%)' : '',
              }"
            />
            <div class="title">{{ item.catName }}</div>
            <div
              v-if="!item.auth"
              class="mask"
              @click.stop="
                () => {
                  return false;
                }
              "
            >
              <img :src="imagePath.suo" alt="" />
              <span>园所暂未合作课程，更多优质内容等您开启！</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-spin>
</template>

<script>
import imagePath from "@/utils/imagePath";
import CommonHeader from "@/components/header/index";
import { mapActions, mapState } from "vuex";
import { queryCategoryName, checkUserAuth } from "@/api/home";
import { imgUrlEncode } from "@/utils/tool.js";

export default {
  name: "Home",
  components: {
    CommonHeader
  },
  data() {
    return {
      imagePath,
      listData: [], // 一级学科列表
      subjectAuth: [], // 一级学科权限
      loading: false // loading
    };
  },
  computed: {
    ...mapState({ userInfo: (state) => state.user.userInfo })
  },
  async created() {
    this.getUserInfo();
    await this.checkUserAuth();
    await this.queryCategoryName(0);
  
  },
  methods: {
    ...mapActions(["GetUserInfo"]),
    // 获取一级学科图片
    // getbgi(index, auth) {
    //   switch (index) {
    //     case 0:
    //       return auth ? this.imagePath.bgi1 : this.imagePath.markBGI1;
    //     case 1:
    //       return auth ? this.imagePath.bgi2 : this.imagePath.markBGI2;
    //     case 2:
    //       return auth ? this.imagePath.bgi3 : this.imagePath.markBGI3;
    //     case 3:
    //       return auth ? this.imagePath.bgi4 : this.imagePath.markBGI4;
    //   }
    // },
    // 获取用户信息
    getUserInfo() {
      this.GetUserInfo()
        .then((res) => console.log(res))
        .catch((err) => console.log(err));
    },
    // 跳转到首页详情
    goHomeDetail(val) {
      // console.log(val, "val");
      this.$router.push({
        path: "/homeDetails",
        query: {
          // 一级学科id
          id: val.catId
        }
      });
    },
    // 设置权限
    setAuth() {
      this.listData.forEach((item) => {
        console.log('item:', item);
        
        const auth = this.subjectAuth.some((i) => i === item.catId);
        this.$set(item, "auth", auth);
      });
      console.log(this.listData, "listData");
    },
    // 查询首页一级学科权限
    async checkUserAuth() {
      this.loading = true;
      const { status, data, msg } = await checkUserAuth();
      this.loading = false;
      if (status === 200) {
        console.log(data, "checkUserAuth");
        this.subjectAuth = data;
       
      } else {
        this.$message.error(msg);
      }
    },
    // 查询一级学科列表
    async queryCategoryName(id) {
      this.loading = true;
      const { status, data, msg } = await queryCategoryName(id);
      this.loading = false;
      console.log('查询一级学科列表:', data);
      
      
      if (status === 200) {
        // this.listData = 
        const unlock = data.map((item) => {
              console.log('查询一级学科列表：', item.catId);
          return {
            ...item,
            auth: this.subjectAuth.includes(item.catId),
            imgUrl: imgUrlEncode(item.imgUrl),
          };
        }).filter((item) => item.auth)
        console.log('unlock:', unlock);
        
        this.subjectAuth.forEach((catId) => {
          const target = unlock.find(item => item.catId === catId)
          if (target) {
            this.listData.push(target)
          }
      
        }); 

        console.log('listData:', this.listData);
        

        const lock = data.map((item) => {
          return {
            ...item,
            auth: this.subjectAuth.includes(item.catId),
            imgUrl: imgUrlEncode(item.imgUrl)
          };
        }).filter((item) => !item.auth);
        this.listData.push(...lock);
      } else {
        this.$message.error(msg);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  // overflow: hidden;
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 50px;

    .tips {
      margin-top: -20px;
      width: 100%;
      display: flex;
      justify-content: center;
      text-align: center;
      img {
        width: 60%;
        height: 80%;
        object-fit: cover;
      }
    }

    .list {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 45px;
      width: 1216px;

      .item {
        position: relative;
        margin-bottom: 26px;
        width: 572px;
        height: 386px;
        // background: #d8d8d8;
        box-sizing: border-box;
        border-radius: 80px;
        background-size: cover;
        background-repeat: no-repeat;
        overflow: hidden;
        transition: all 0.25s ease-in;
        -moz-transition: all 0.25s ease-in;
        -webkit-transition: all 0.25s ease-in;

        .itemBGI {
          position: absolute;
          width: 100%;
          height: 100%;
        }

        .title {
          position: absolute;
          bottom: 46px;
          width: 573px;
          height: 28px;
          font-size: 26px;
          font-weight: normal;
          color: #333333;
          line-height: 28px;
          text-align: center;
        }

        .mask {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          position: absolute;
          z-index: 999;
          width: 100%;
          height: 100%;

          img {
            margin-bottom: 11px;
            width: 24px;
            height: 30px;
          }

          span {
            font-size: 18px;
            color: #ffffff;
            text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.5);
          }
        }
      }

      .item:nth-child(odd) {
        margin-right: 69px;
      }

      .item:hover {
        /*Y轴上表示上升*/

        .title {
          font-weight: 600;
        }

        transform: translateY(-10px);
      }
    }
  }
}
</style>
